export const getUpdatedCells = (address: string) => {
  const args = address.split(",");
  const updatedCells = [];

  args.forEach((arg) => {
    if (arg.includes(":")) {
      const [start, end] = arg.split(":");
      const [startCol, startRow] = start.split(/(\d+)/);
      const [endCol, endRow] = end.split(/(\d+)/);

      for (let i = parseInt(startRow); i <= parseInt(endRow); i++) {
        for (let j = startCol.charCodeAt(0); j <= endCol.charCodeAt(0); j++) {
          updatedCells.push(String.fromCharCode(j) + i);
        }
      }

      return;
    }

    updatedCells.push(arg);
  });

  return updatedCells;
};
